import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useLocation from '@skippay/core/hooks/useLocation';
import { setFriendsAndFamilyState } from '@skippay/core/modules/misc';

function useExperimentalFnFFeaturesToggle(): void {
	const dispatch = useDispatch();
	const {
		location: { query },
	} = useLocation();

	useEffect(() => {
		const { experimentalFnFFeatures } = query || {};
		if (experimentalFnFFeatures === 'enable' || experimentalFnFFeatures === 'disable') {
			dispatch(setFriendsAndFamilyState(experimentalFnFFeatures === 'enable'));
		}
	}, [dispatch, query]);
}

export default useExperimentalFnFFeaturesToggle;
